import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NowWallpaperIcon(props: IconProps) {
    return <Icon {...props} iconKey={"now_wallpaper"}/>
}
